import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var justify_top_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M9 20h6V9H9v11zM4 4v1.5h16V4H4z" }) });
export {
  justify_top_default as default
};
//# sourceMappingURL=justify-top.js.map
